module.exports = __webpack_public_path__ + "static/media/about.8b4f96db.svg";